import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Router } from '@angular/router';

import { FileItem } from '../shared/models/file-item.model';
import { WacContentService } from '../shared/services/wac-content.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { BaseRouteGuard } from './base.route-guard';

@Injectable({
    providedIn: 'root'
})
export class WacContentHostRouteGuard extends BaseRouteGuard implements CanActivate, CanLoad {

    constructor(
        capabilitiesService: CapabilitiesService,
        router: Router,
        private readonly wacContentService: WacContentService
    ) {
        super(router, capabilitiesService);
    }

    public async canActivate(route: ActivatedRouteSnapshot) {
        await this.wacContentService.bootstrapDocumentFromLoader(
            this.wacContentService.getDocumentInfoFromParams(route.queryParams, FileItem.fileTypeNameToFileType(route.params['app'])),
            Date.now(),
            true
        );
        return this.checkEnabledAndRedirect(this.capabilitiesService.wacHostEnabled());
    }

    public canLoad() {
        return this.checkEnabledAndRedirect(this.capabilitiesService.wacHostEnabled());
    }
}
